import { render } from "./CollectionSourceTransactions.vue?vue&type=template&id=5e6c89e5&scoped=true"
import script from "./CollectionSourceTransactions.vue?vue&type=script&lang=js"
export * from "./CollectionSourceTransactions.vue?vue&type=script&lang=js"

import "./CollectionSourceTransactions.vue?vue&type=style&index=0&id=5e6c89e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6c89e5"]])

export default __exports__